import { type ReactElement } from "react";
import { Box, Typography } from "@mui/material";
import { QuestionBooleanModel } from "survey-core";

type GlBooleanProps = {
  question: QuestionBooleanModel;
  isReadOnly?: boolean;
};

const GlBoolean = ({
  question,
  isReadOnly = false
}: GlBooleanProps): ReactElement => {
  const leftValue = question.swapOrder;
  const rightValue = !question.swapOrder;

  const options = [
    { value: leftValue, label: question.locLabelLeft.renderedHtml },
    { value: rightValue, label: question.locLabelRight.renderedHtml }
  ];

  const handleSelect = (value: boolean) => {
    if (isReadOnly || question.isReadOnly) return;
    question.booleanValue = value;
  };

  const isSelected = (value: boolean): boolean => question.booleanValue === value;

  return (
    <Box
      className="glboolean"
      role="radiogroup"
      aria-required={question.a11y_input_ariaRequired || undefined}
      aria-invalid={question.a11y_input_ariaInvalid || undefined}
      aria-label={question.a11y_input_ariaLabel || undefined}
      aria-labelledby={question.a11y_input_ariaLabelledBy || undefined}
      aria-describedby={question.a11y_input_ariaDescribedBy || undefined}
    >
      <Box className="glboolean__row">
        {options.map((option) => {
          const selected = isSelected(option.value);

          return (
            <Box
              key={String(option.value)}
              className={`glboolean__option${selected ? " glboolean__option--selected" : ""}`}
              component="label"
            >
              <input
                className="glboolean__input"
                type="radio"
                name={question.name}
                value={String(option.value)}
                checked={selected}
                disabled={isReadOnly || question.isReadOnly}
                onChange={() => handleSelect(option.value)}
              />
              {selected ? (
                <Box className="glboolean__check" aria-hidden="true" />
              ) : (
                <Box className="glboolean__radio" aria-hidden="true" />
              )}
              <Typography className="glboolean__label" component="span">
                {option.label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default GlBoolean;
